<div class="table-chart-container">
    <header>
        <div>
            {{chatResponse.chartConfig?.title ?? 'Data View'}}
        </div>
        <div *ngIf="chatResponse?.chartConfig">
            <p-selectButton 
                [options]="toggleOptions" 
                [(ngModel)]="toggleValue" 
                optionLabel="label" 
                optionValue="value" />
        </div>
    </header>
    <main>
        @if(toggleValue === 'table') {
            <app-chat-response-tables 
                [chatTable]="chatResponse.responseTables[0]"
            />
        } @else {
            <app-chart-visualizer
                [chartType]="chatResponse.chartConfig?.chartType"
                [chartConfig]="chatResponse.chartConfig?.config"
                [tableData]="chatResponse.responseTables[0]">
            </app-chart-visualizer>
        }
    </main>
</div>